import React from 'react'
import { Lock1 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Tooltip from '../../../../../../../components/atoms/Tooltip'

import useStyles from './styles'

const tooltipText =
  'This is a system permission and cannot be edited or deleted.'

const NameCell = ({ name, row }) => {
  const theme = useTheme()

  const classes = useStyles()
  const { system } = row

  return (
    <div className={classes.root}>
      {system && (
        <Tooltip title={tooltipText} placement='bottom-start' arrow>
          <div className={classes.root}>
            <Lock1 size={theme.size.sm} className={classes.icon} />
          </div>
        </Tooltip>
      )}
      {name}
    </div>
  )
}

export default NameCell
